import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../context/AuthContext";
import { toast } from "sonner";
import { Radio, RefreshCw, Link2, CheckCircle2 } from "lucide-react";

const inp = "w-full bg-black/40 border border-white/10 rounded-md px-3 py-2 text-sm outline-none focus:border-[#FF1E27]";

export default function FicrPanel({ g, rallyId, load }) {
  const ficr = g.rally.ficr;
  const [q, setQ] = useState(g.rally.name.split(" ").slice(-2).join(" "));
  const [events, setEvents] = useState([]);
  const [races, setRaces] = useState([]);
  const [sel, setSel] = useState(null);
  const [raceId, setRaceId] = useState(1);
  const [busy, setBusy] = useState(false);
  const [report, setReport] = useState(null);

  const search = async () => {
    setBusy(true);
    try { const { data } = await axios.get(`${API}/organizer/ficr/events`, { params: { year: 2026, q } }); setEvents(data); if (!data.length) toast.info("Nessuna gara trovata su FICR"); }
    catch (e) { toast.error(e.response?.data?.detail || "FICR non raggiungibile"); } finally { setBusy(false); }
  };
  const pick = async (ev) => {
    setSel(ev); setRaceId(ev.race_id);
    try { const { data } = await axios.get(`${API}/organizer/ficr/events/${ev.year}/${ev.team_code}/${ev.show_id}/races`); setRaces(data); if (data[0]) setRaceId(data[0].race_id); } catch { setRaces([]); }
  };
  const link = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/organizer/rallies/${rallyId}/ficr/link`, { ...sel, race_id: raceId, event_name: sel.name });
      toast.success(`Collegato a FICR · ${data.stages_total} PS (${data.stages_created} nuove)`); setSel(null); setEvents([]); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Errore"); } finally { setBusy(false); }
  };
  const sync = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/organizer/rallies/${rallyId}/ficr/sync`);
      setReport(data);
      toast.success(`${data.settled} pronostici chiusi · PS completate ${data.done_ps}/${data.total_ps}`); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Errore"); } finally { setBusy(false); }
  };
  useEffect(() => { setReport(null); }, [rallyId]);

  return (
    <div className="rl-card p-6 lg:col-span-2" data-testid="ficr-panel">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-1">
        <h2 className="font-display font-bold text-xl flex items-center gap-2"><Radio className="w-5 h-5 text-[#30D158]" /> Tempi ufficiali live · FICR</h2>
        {ficr && <button className="btn-crimson !py-2 !px-4 text-xs" onClick={sync} disabled={busy} data-testid="ficr-sync-btn"><RefreshCw className={`w-4 h-4 inline mr-1 ${busy ? "animate-spin" : ""}`} />SINCRONIZZA RISULTATI</button>}
      </div>
      <p className="text-xs text-slate-500 mb-4">Collega il rally al cronometraggio ufficiale FICR (rally.ficr.it): le PS vengono importate e i pronostici FANTARALLY si chiudono in automatico con i tempi ufficiali (PS, assoluta e classi a fine gara).</p>

      {ficr ? (
        <div className="border border-[#30D158]/30 rounded-lg p-4 flex flex-wrap items-center justify-between gap-3" data-testid="ficr-linked">
          <div className="flex items-center gap-3">
            <CheckCircle2 className="w-6 h-6 text-[#30D158]" />
            <div>
              <div className="font-semibold">{ficr.event_name || `FICR ${ficr.year}/${ficr.team_code}/${ficr.show_id}`}</div>
              <div className="text-xs font-mono-rl text-slate-400">
                {ficr.last_sync ? `Ultimo sync ${new Date(ficr.last_sync).toLocaleString("it-IT")} · PS ${ficr.done_ps}/${ficr.total_ps}${ficr.finished ? " · GARA CONCLUSA" : ""}` : "Mai sincronizzato"}
              </div>
            </div>
          </div>
          <button className="text-xs text-slate-500 hover:text-white" onClick={() => setEvents([{ placeholder: true }])} data-testid="ficr-relink">Cambia gara</button>
        </div>
      ) : null}

      {(!ficr || events.length > 0) && (
        <div className="mt-4">
          <div className="flex gap-2">
            <input className={inp} value={q} onChange={e => setQ(e.target.value)} placeholder="Cerca la gara su FICR (es. Valli Ossolane)" data-testid="ficr-search-input" onKeyDown={e => e.key === "Enter" && search()} />
            <button className="btn-outline-rl !py-2 !px-4 text-xs" onClick={search} disabled={busy} data-testid="ficr-search-btn">CERCA</button>
          </div>
          <div className="mt-3 space-y-1 max-h-48 overflow-y-auto">
            {events.filter(e => !e.placeholder).map(ev => (
              <button key={`${ev.team_code}-${ev.show_id}`} onClick={() => pick(ev)} data-testid={`ficr-event-${ev.team_code}-${ev.show_id}`}
                className={`w-full text-left border rounded-lg px-3 py-2 text-sm transition ${sel?.show_id === ev.show_id && sel?.team_code === ev.team_code ? "border-[#30D158] bg-[#30D158]/10" : "border-white/5 hover:border-[#30D158]/40"}`}>
                <span className="font-semibold">{ev.name}</span> <span className="text-xs text-slate-500 font-mono-rl ml-2">{ev.date} · {ev.place}</span>
              </button>
            ))}
          </div>
          {sel && (
            <div className="flex flex-wrap gap-2 mt-3 items-center">
              {races.length > 1 && (
                <select className={`${inp} !w-auto`} value={raceId} onChange={e => setRaceId(parseInt(e.target.value))} data-testid="ficr-race-select">
                  {races.map(r => <option key={r.race_id} value={r.race_id}>{r.name}</option>)}
                </select>
              )}
              <button className="btn-crimson !py-2 !px-4 text-xs" onClick={link} disabled={busy} data-testid="ficr-link-btn"><Link2 className="w-4 h-4 inline mr-1" />COLLEGA E IMPORTA PS</button>
            </div>
          )}
        </div>
      )}

      {report && (
        <div className="mt-4 border border-white/5 rounded-lg p-3 text-xs font-mono-rl space-y-1" data-testid="ficr-report">
          <div className="text-slate-400">PS completate {report.done_ps}/{report.total_ps} · {report.settled} pronostici chiusi{report.rally_finished ? " · gara conclusa" : ""}</div>
          {report.report.map((l, i) => <div key={i} className="text-[#30D158]">✓ {l}</div>)}
          {report.report.length === 0 && <div className="text-slate-500">Nessun nuovo risultato da chiudere.</div>}
        </div>
      )}
    </div>
  );
}
